var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center mt-4 pa-0"},[_c('h1',[_vm._v(" Recipes ")])])],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('Recipes')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }